import { Record } from 'immutable';

export const QuestionnaireResume = new Record({
  isPending: false,
  error: null,
  data: []
});